import React from 'react';
import styled from 'styled-components';
import { SectionName, PaddedContainer } from '../common/styles';

const Container = styled(PaddedContainer)`
  padding: ${props => (props.theme.isMobile ? '116px 0 73px' : '122px 0 134px 0')};
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
`;

const Title = styled(SectionName)`
  color: ${props => props.theme.bodyColor};
  margin-bottom: 24px;
  font-size: 20px;
`;

const Desc = styled.p`
  margin: 0;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBook};
  font-size: ${props => (props.theme.isMobile ? 35 : 40)}px;
  line-height: ${props => (props.theme.isMobile ? 36 : 41)}px;
  color: ${props => props.theme.bodyColor};
`;

export default function Mission() {
  return (
    <Container>
      <Title>our mission</Title>
      <Desc>Livewire is Australia’s #1 source of investment ideas</Desc>
    </Container>
  );
}
